export interface AuthConfig {
    issuer: string;
    clientId: string;
    redirectUri: string;
    scopes: string[];
    pkce: boolean;
    postLogoutRedirectUri: string;
  }
  
  export class OktaAuthConfig {
    constructor(public config: AuthConfig) { }
  }